import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {},
	createButtons: {
		marginBottom: 16,
		...CssSelectors.allChildren({
			maxWidth: '25%',
		}),
	},
});
